import { render, staticRenderFns } from "./PhotosFeed.vue?vue&type=template&id=1a30b566&"
import script from "./PhotosFeed.vue?vue&type=script&lang=ts&"
export * from "./PhotosFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports